
import { Component, Vue, Watch } from 'vue-property-decorator';
import ConfirmDialog from '../core/components/Modals/ConfirmDialog.vue'
import GlobalSnackbar from '../core/components/Modals/GlobalSnackbar.vue'
import HighCloudyImageConfirmDialog from '../features/claim-blocks/satellital/HighCloudyImageConfirmDialog.vue'

@Component({
  components: {
    ConfirmDialog,
    GlobalSnackbar,
    HighCloudyImageConfirmDialog,
  }
})
export default class App extends Vue {

  @Watch('$route', { immediate: true, deep: true })
  onUrlChange() {
    // ...
  }

}
